import React, { useState, useEffect, useContext } from "react";
import ProfileContactInfo from "./ProfileComponents/ProfileContactInfo";
import ProfileAddressBook from "./ProfileComponents/ProfileAddressBook";
import ProfileOrderHistory from "./ProfileComponents/ProfileOrderHistory";
import ProfileWishList from "./ProfileComponents/ProfileWishList";
import { useHistory, useParams, useLocation } from "react-router-dom";
import ProfilePromoCodes from "./ProfileComponents/ProfilePromoCodes";
import ArrowDown from "../Images/ArrowDown.png";
import { AppContext, useAppContext } from "./../AppContext";
import { useTranslation } from "react-i18next";

export default function Profile() {
  const { t, i18n } = useTranslation();

  const { CartAmount, setCartAmount, setWishList, WishList } =
    useContext(AppContext);

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();
  const { profilecomp } = useParams();
  const location = useLocation();

  const handleDivClick = (profilecomp) => {
    //window.location.assign(`/${profilecomp}`); // Full reload, but keeps history
    history.push(`/${profilecomp}`); // Navigate to the root path
  };

  const [ChoosePage, setChoosePage] = useState(0);
  useEffect(() => {
    if (location.pathname === "/profile/contact-info") {
      setChoosePage(0);
    } else if (location.pathname === "/profile/address-book") {
      setChoosePage(1);
    } else if (location.pathname === "/profile/history-order") {
      setChoosePage(2);
    } else if (location.pathname === "/profile/wish-list") {
      setChoosePage(3);
    } else if (location.pathname === "/profile/promo-codes") {
      setChoosePage(4);
    } else {
      //setChoosePage(0); // Optional: Set default value for other routes
    }
  }, [location.pathname]);

  const WindowsCats = () => {
    return (
      <>
        <div
          style={{
            direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            paddingRight: i18n.resolvedLanguage === "en" ? 0 : 20,
            width: "20%",
            paddingTop: 50,
          }}
        >
          <p
            onClick={() => {
              handleDivClick("profile/contact-info");
            }}
            style={{
              color: ChoosePage === 0 ? "#6b21a8" : "black",
              cursor: "pointer",
            }}
          >
            {t("profile.ContactInfo")}
          </p>
          <p
            onClick={() => {
              handleDivClick("profile/address-book");
            }}
            style={{
              color: ChoosePage === 1 ? "#6b21a8" : "black",
              cursor: "pointer",
            }}
          >
            {t("profile.AddressBook")}
          </p>
          <p
            onClick={() => {
              handleDivClick("profile/history-order");
            }}
            style={{
              color: ChoosePage === 2 ? "#6b21a8" : "black",
              cursor: "pointer",
            }}
          >
            {t("profile.Orderhistory")}
          </p>
          <p
            onClick={() => {
              handleDivClick("profile/wish-list");
            }}
            style={{
              color: ChoosePage === 3 ? "#6b21a8" : "black",
              cursor: "pointer",
            }}
          >
            {t("profile.Wishlist")}
          </p>

          <p
            onClick={() => {
              handleDivClick("profile/promo-codes");
            }}
            style={{
              color: ChoosePage === 4 ? "#6b21a8" : "black",
              cursor: "pointer",
            }}
          >
            {t("profile.Promocodes")}
          </p>
          <p
            style={{
              marginTop: 70,
              opacity: 0.5,
              cursor: "pointer",
            }}
            onClick={() => {
              //localStorage.clear();
              localStorage.removeItem("role");
              localStorage.removeItem("token");
              localStorage.removeItem("user");
              setCartAmount(0);
              setWishList([]);
              handleDivClick("");
              window.location.reload(); // This will force a full page reload
            }}
          >
            {t("profile.Logoff")}
          </p>
        </div>
        <div
          style={{
            width: "1px",
            backgroundColor: "#ccc", // Set line color
            alignSelf: "stretch", // Keeps the line stretched in case of container height changes
            height: 500,
            marginTop: 50,
            marginLeft: i18n.resolvedLanguage === "en" ? 0 : 20,
          }}
        ></div>
        <div style={{ flex: 1 }}>
          {location.pathname === "/profile/wish-list" && <ProfileWishList />}

          {location.pathname === "/profile/address-book" && (
            <ProfileAddressBook />
          )}

          {location.pathname === "/profile/history-order" && (
            <ProfileOrderHistory />
          )}

          {location.pathname === "/profile/promo-codes" && (
            <ProfilePromoCodes />
          )}

          {(location.pathname === "/profile/contact-info" && (
            <ProfileContactInfo />
          )) ||
            (location.pathname === "/profile" && <ProfileContactInfo />)}
        </div>
      </>
    );
  };
  const [OpenInMobile, setOpenInMobile] = useState(
    location.pathname === "/profile/wish-list" ? true : false
  );
  const MobileCats = () => {
    return (
      <>
        <div
          style={{
            width: "100%",
            paddingTop: 50,
            //backgroundColor: "red",
            paddingLeft: MyWidth <= 768 ? "2%" : "0%",
            paddingRight: MyWidth <= 768 ? "2%" : "0%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 15,
            }}
            onClick={() => {
              handleDivClick("profile/contact-info");
              if (ChoosePage !== 0 && !OpenInMobile) {
                setOpenInMobile(true);
              } else if (ChoosePage === 0 && OpenInMobile) {
                setOpenInMobile(false);
              } else {
                setOpenInMobile(true);
              }
            }}
          >
            <a
              style={{
                color: ChoosePage === 0 && OpenInMobile ? "#6b21a8" : "black",
                cursor: "pointer",
              }}
            >
              {t("profile.ContactInfo")}
            </a>
            <span
              style={{
                display: "inline-block",
                transition: "transform 0.3s ease", // Smooth transition for the rotation
                transform:
                  ChoosePage === 0 && OpenInMobile
                    ? "rotate(180deg)"
                    : "rotate(0deg)", // Rotate the arrow
                color: "black",
              }}
            >
              <img
                src={ArrowDown}
                style={{
                  width: 12,
                  height: 12,
                  //opacity: currentSlide === 0 ? 0.3 : 1,
                  //cursor: currentSlide === 0 ? "" : "pointer",
                }}
              />
            </span>
          </div>
          {ChoosePage === 0 && OpenInMobile ? (
            <>
              {(location.pathname === "/profile/contact-info" && (
                <ProfileContactInfo />
              )) ||
                (location.pathname === "/profile" && <ProfileContactInfo />)}
            </>
          ) : (
            <></>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 15,
            }}
            onClick={() => {
              handleDivClick("profile/address-book");
              if (ChoosePage !== 1 && !OpenInMobile) {
                setOpenInMobile(true);
              } else if (ChoosePage === 1 && OpenInMobile) {
                setOpenInMobile(false);
              } else {
                setOpenInMobile(true);
              }
            }}
          >
            <a
              style={{
                color: ChoosePage === 1 && OpenInMobile ? "#6b21a8" : "black",
                cursor: "pointer",
              }}
            >
              {t("profile.AddressBook")}
            </a>
            <span
              style={{
                display: "inline-block",
                transition: "transform 0.3s ease", // Smooth transition for the rotation
                transform:
                  ChoosePage === 1 && OpenInMobile
                    ? "rotate(180deg)"
                    : "rotate(0deg)", // Rotate the arrow
                color: "black",
              }}
            >
              <img
                src={ArrowDown}
                style={{
                  width: 12,
                  height: 12,
                  //opacity: currentSlide === 0 ? 0.3 : 1,
                  //cursor: currentSlide === 0 ? "" : "pointer",
                }}
              />
            </span>
          </div>
          {ChoosePage === 1 && OpenInMobile ? (
            <>
              {location.pathname === "/profile/address-book" && (
                <ProfileAddressBook />
              )}
            </>
          ) : (
            <></>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 15,
            }}
            onClick={() => {
              handleDivClick("profile/history-order");
              if (ChoosePage !== 2 && !OpenInMobile) {
                setOpenInMobile(true);
              } else if (ChoosePage === 2 && OpenInMobile) {
                setOpenInMobile(false);
              } else {
                setOpenInMobile(true);
              }
            }}
          >
            <a
              style={{
                color: ChoosePage === 2 && OpenInMobile ? "#6b21a8" : "black",
                cursor: "pointer",
              }}
            >
              {t("profile.Orderhistory")}
            </a>
            <span
              style={{
                display: "inline-block",
                transition: "transform 0.3s ease", // Smooth transition for the rotation
                transform:
                  ChoosePage === 2 && OpenInMobile
                    ? "rotate(180deg)"
                    : "rotate(0deg)", // Rotate the arrow
                color: "black",
              }}
            >
              <img
                src={ArrowDown}
                style={{
                  width: 12,
                  height: 12,
                  //opacity: currentSlide === 0 ? 0.3 : 1,
                  //cursor: currentSlide === 0 ? "" : "pointer",
                }}
              />
            </span>
          </div>
          {ChoosePage === 2 && OpenInMobile ? (
            <>
              {location.pathname === "/profile/history-order" && (
                <ProfileOrderHistory />
              )}
            </>
          ) : (
            <></>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 15,
            }}
            onClick={() => {
              handleDivClick("profile/wish-list");
              if (ChoosePage !== 3 && !OpenInMobile) {
                setOpenInMobile(true);
              } else if (ChoosePage === 3 && OpenInMobile) {
                setOpenInMobile(false);
              } else {
                setOpenInMobile(true);
              }
            }}
          >
            <a
              onClick={() => {
                handleDivClick("profile/wish-list");
                if (ChoosePage !== 3 && !OpenInMobile) {
                  setOpenInMobile(true);
                } else if (ChoosePage === 3 && OpenInMobile) {
                  setOpenInMobile(false);
                } else {
                  setOpenInMobile(true);
                }
              }}
              style={{
                color: ChoosePage === 3 && OpenInMobile ? "#6b21a8" : "black",
                cursor: "pointer",
              }}
            >
              {t("profile.Wishlist")}
            </a>
            <span
              style={{
                display: "inline-block",
                transition: "transform 0.3s ease", // Smooth transition for the rotation
                transform:
                  ChoosePage === 3 && OpenInMobile
                    ? "rotate(180deg)"
                    : "rotate(0deg)", // Rotate the arrow
                color: "black",
              }}
            >
              <img
                src={ArrowDown}
                style={{
                  width: 12,
                  height: 12,
                  //opacity: currentSlide === 0 ? 0.3 : 1,
                  //cursor: currentSlide === 0 ? "" : "pointer",
                }}
              />
            </span>
          </div>
          {ChoosePage === 3 && OpenInMobile ? (
            <>
              {location.pathname === "/profile/wish-list" && (
                <ProfileWishList />
              )}
            </>
          ) : (
            <></>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 15,
            }}
            onClick={() => {
              handleDivClick("profile/promo-codes");
              if (ChoosePage !== 4 && !OpenInMobile) {
                setOpenInMobile(true);
              } else if (ChoosePage === 4 && OpenInMobile) {
                setOpenInMobile(false);
              } else {
                setOpenInMobile(true);
              }
            }}
          >
            <a
              style={{
                color: ChoosePage === 4 && OpenInMobile ? "#6b21a8" : "black",
                cursor: "pointer",
              }}
            >
              {t("profile.Promocodes")}
            </a>
            <span
              style={{
                display: "inline-block",
                transition: "transform 0.3s ease", // Smooth transition for the rotation
                transform:
                  ChoosePage === 4 && OpenInMobile
                    ? "rotate(180deg)"
                    : "rotate(0deg)", // Rotate the arrow
                color: "black",
              }}
            >
              <img
                src={ArrowDown}
                style={{
                  width: 12,
                  height: 12,
                  //opacity: currentSlide === 0 ? 0.3 : 1,
                  //cursor: currentSlide === 0 ? "" : "pointer",
                }}
              />
            </span>
          </div>

          {ChoosePage === 4 && OpenInMobile ? (
            <>
              {location.pathname === "/profile/promo-codes" && (
                <ProfilePromoCodes />
              )}
            </>
          ) : (
            <></>
          )}
          <p
            style={{
              marginTop: 70,
              opacity: 0.5,
              cursor: "pointer",
            }}
            onClick={() => {
              //localStorage.clear();
              localStorage.removeItem("role");
              localStorage.removeItem("token");
              localStorage.removeItem("user");
              setCartAmount(0);
              setWishList([]);
              handleDivClick("");
              window.location.reload(); // This will force a full page reload
            }}
          >
            {t("profile.Logoff")}
          </p>
        </div>
      </>
    );
  };
  return (
    <div
      style={{
        display: "flex",
        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
      }}
    >
      {MyWidth <= 768 ? <>{MobileCats()}</> : <>{WindowsCats()}</>}
    </div>
  );
}
